<script>
  import { createEventDispatcher, onMount } from "svelte"
  import notify from "../../../../../../Script/notify"
  const dispatch = createEventDispatcher()

  let url = ""
  let title = ""
  export let selected

  /**
   * @typedef {Object} notification
   * @property {Function} close - Closes the notification.
   */

  /**
   * @type {notification}
   */
  let notification = {
    close() {},
  }

  onMount(() => {
    try {
      title = selected.toLocaleString()
    } catch (error) {
      console.error(error)
    }
  })

  const handleInsertLink = () => {
    try {
      if (!title.trim()) throw "Kindly Enter Text to display"
      if (!url.trim()) throw "Kindly Enter URL"

      const URL_REGEX = /^(https:\/\/|#|http:\/\/)/
      if (!URL_REGEX.test(url)) throw "Please enter a URL that starts with either 'http://' or 'https://'."

      dispatch("insert", { url, title })
    } catch (error) {
      console.error(error)
      notification.close()
      const info = "PAGE: Edit Email template\nEVENT: While validating URL to insert"
      notification = notify.danger(error, info)
    }
  }
</script>

<div class="fixed inset-0 z-10 flex items-center justify-center overflow-hidden bg-[#000000cc] backdrop-blur-md">
  <form on:submit|preventDefault={handleInsertLink}>
    <div class="relative m-6 w-[700px] transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0">
      <div class="flex w-full items-center justify-center rounded-md bg-white p-6 text-black dark:bg-bodyblack">
        <h1 class="text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Insert Link</h1>
      </div>

      <div class="flex w-full flex-col items-center gap-6 px-8 py-5 text-gray-400">
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="col-span-2 mb-1 block select-none text-base font-medium text-gray-500 sm:mb-0">Text to display</div>
          <div class="col-span-2 sm:mt-0">
            <input required bind:value={title} type="text" class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 invalid:focus:border-red-500 invalid:focus:ring-red-500 dark:text-white" placeholder="Enter Text to display" />
          </div>
        </div>
        <div class="w-full items-center sm:grid sm:grid-cols-4">
          <div class="col-span-2 mb-1 block select-none text-base font-medium text-gray-500 sm:mb-0">To what URL should this link go ?</div>
          <div class="col-span-2 sm:mt-0">
            <input required bind:value={url} type="text" class="block w-full appearance-none rounded-md border border-[#a0a1a580] bg-transparent px-3 py-2 pl-5 text-sm text-gray-800 placeholder-gray-200 outline-none invalid:animate-shake invalid:border-red-500 invalid:placeholder-red-500 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 invalid:focus:border-red-500 invalid:focus:ring-red-500 dark:text-white" placeholder="Enter URL" />
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-6 dark:bg-bodyblack sm:flex md:gap-0">
        <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-circle-xmark" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Close</span>
        </button>

        <button disabled={!url} type="submit" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-[#f7f7f7]/50 disabled:text-gray-900/50 dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto">
          <span>
            <i class="fa-solid fa-link" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Insert Link</span>
        </button>
      </div>
    </div>
  </form>
</div>
